<template>
  <div class="tc-container">
    <div class="el-bgfh">
      <div>本月</div>
      <div>上月</div>
      <div>去年同期</div>
    </div>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 1,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let xLabel = ['0', '2', '4', '6', '8', '10', '12']
        let goOutSchool = ['20', '7', '18', '4', '19', '8', '6']

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: '#57617B',
              },
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: '#808487',
                },
              },
              axisLabel: {
                textStyle: {
                  color: '#E6E6E6',
                  fontSize: 12,
                },
              },
              data: xLabel,
            },
          ],
          yAxis: [
            {
              type: 'value',
              min: 0,
              max: 20,
              splitNumber: 7,
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#57617B',
                },
              },
              axisLabel: {
                margin: 10,
                textStyle: {
                  color: '#fff',
                  fontSize: 12,
                },
              },
              splitLine: {
                lineStyle: {
                  color: '#4D5054',
                },
              },
            },
          ],
          series: [
            {
              name: '注册总量',
              type: 'line',
              // smooth: true, //是否平滑曲线显示
              // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
              symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
              symbolSize: 0,
              smooth: true,
              showAllSymbol: true,
              lineStyle: {
                normal: {
                  color: '#FFC600', // 线条颜色
                },
                borderColor: '#f0f',
              },
              label: {
                show: false,
                position: 'top',
                textStyle: {
                  color: '#fff',
                },
              },
              itemStyle: {
                normal: {
                  color: '#28ffb3',
                },
              },
              tooltip: {
                show: false,
              },
              areaStyle: {
                //区域填充样式
                normal: {
                  //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: 'transparent',
                      },
                      {
                        offset: 1,
                        color: 'transparent',
                      },
                    ],
                    false
                  ),
                  shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                  shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                },
              },
              data: [0, 1, 4, 18, 6, 14, 18],
            },
            {
              name: '',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 2,
                },
              },
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: '#086147',
                      },
                      {
                        offset: 1,
                        color: '#0A4034',
                      },
                    ],
                    false
                  ),
                  shadowColor: 'rgba(0, 0, 0, 0.1)',
                  shadowBlur: 10,
                },
              },
              itemStyle: {
                normal: {
                  color: '#02E493',
                },
                emphasis: {
                  color: 'rgb(0,196,132)',
                  borderColor: 'rgba(0,196,132,0.2)',
                  extraCssText: 'box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);',
                  borderWidth: 10,
                },
              },
              data: goOutSchool,
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin tongy($a) {
    content: '';
    width: 16px;
    display: inline-block;
    height: 3px;
    background: $a;
    margin-right: 8px;
    position: relative;
    bottom: 4px;
  }
  .tc-container {
    .el-bgfh {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #fff;
      white-space: nowrap;
      div:nth-child(1) {
        &::before {
          @include tongy(#02ffa3);
        }
      }
      div:nth-child(2) {
        &::before {
          @include tongy(#ffc600);
        }
        margin: 0 20px;
      }
      div:nth-child(3) {
        &::before {
          @include tongy(#19bffa);
        }
      }
    }
    .tp-chart {
      margin-top: 20px;
      width: 100%;
      height: 7.6vw;
    }
  }
</style>
